//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import indeterminateCheckboxTemplate from '@legacy-components/common/indeterminate-checkbox/indeterminate-checkbox.html';

(function() {
  angular.module('curalate').constant('INDETERMINATE_CHECKBOX_STATES', {
    CHECKED: 'CHECKED',
    INDETERMINATE: 'INDETERMINATE',
    UNCHECKED: 'UNCHECKED',
  }).component('indeterminateCheckbox', {
    bindings: {
      state: '<', // CHECKED, INDETERMINATE, UNCHECKED
      locked: '<',
      onStateChange: '&',
      showLabelOnly: '<',
      checkboxLabel: '<',
    },
    transclude: true,
    template: indeterminateCheckboxTemplate,
    controller: [
      '$log',
      '$scope',
      'INDETERMINATE_CHECKBOX_STATES',
      function(
                $log,
                $scope,
                INDETERMINATE_CHECKBOX_STATES,
            ) {
        const self = this;
        self.checked = false;
        self.isIndeterminate = false;

        this.$onChanges = function(changesObj) {
          if (changesObj.state) {
            self.checked = changesObj.state.currentValue === INDETERMINATE_CHECKBOX_STATES.CHECKED;
            self.isIndeterminate = changesObj.state.currentValue === INDETERMINATE_CHECKBOX_STATES.INDETERMINATE;
          }
        };

        $scope.$watch('$ctrl.checked', (newValue, oldValue) => {
          if (newValue && !oldValue && self.state !== INDETERMINATE_CHECKBOX_STATES.CHECKED) {
            self.onStateChange({ state: INDETERMINATE_CHECKBOX_STATES.CHECKED });
          }
          if (!newValue && oldValue && self.state === INDETERMINATE_CHECKBOX_STATES.CHECKED) {
            self.onStateChange({ state: INDETERMINATE_CHECKBOX_STATES.UNCHECKED });
          }
        });
      },
    ],
  });
})();
